@if (downloadMode === fileDownloadMode.SingleFileUsingDropdown) {
  <kendo-dropdownbutton
    [disabled]="files.length === 0"
    [data]="files"
    (itemClick)="downloadFile($event.fileURL)"
    [svgIcon]="filePdfIcon">
    @if (loading) {
      <kendo-loader
        size="small">
      </kendo-loader>
    }
    ({{files.length ?? 0}})
    <ng-template kendoDropDownButtonItemTemplate let-dataItem>
      <span class="k-icon k-i-file-pdf"></span>
      <span>{{ dataItem.fileName }}</span>
    </ng-template>
  </kendo-dropdownbutton>
}

@if (downloadMode === fileDownloadMode.SingleFileUsingChip) {
  @for (f of files; track f) {
    <kendo-chip
      [label]="f.fileName"
      [removable]="true"
      (contentClick)="downloadFile(f.fileURL)"
      (remove)="tryRemoveFile(f.fileName)">
    </kendo-chip>
  }
}

@if (downloadMode === fileDownloadMode.AllFiles) {
  <button
    kendoButton
    themeColor="primary"
    type="button"
    [disabled]="files.length === 0"
    (click)="downloadAndPreviewPDF()"
    [svgIcon]="filePdfIcon">
    @if (loading) {
      <kendo-loader
        size="small">
      </kendo-loader>
    }
    ({{files.length ?? 0}})
  </button>
}

@if (canEdit == true) {
  <kendo-upload
    [saveUrl]="uploadSaveUrl"
    [autoUpload]="false"
    [restrictions]="myRestrictions"
    [disabled]="disabled"
    (upload)="uploadEventHandler($event)"
    (success)="getFiles()">
  </kendo-upload>
}

@if (removeUploadedFile) {
  <app-confirmation-dialog
    (conformationDialogCloseEvent)="confirmRemoveUploadedFile($event)"
    >
  </app-confirmation-dialog>
}
